/**
 * Картинки машин для доски.
 *
 * Список собирается по содержимому `assets/cars` при сборке: положили файл —
 * машина появилась, править код не нужно. Ровно то же правило, по которому
 * живут карты каптов, только те читаются на сервере, а эти уходят в сборку
 * фронта и получают адреса с отпечатком — их можно кэшировать навсегда.
 *
 * Порядок — по имени файла, поэтому нумеровать стоит с ведущим нулём:
 * `10.png` иначе встанет между `01.png` и `02.png`.
 */

const modules = import.meta.glob<string>('../assets/cars/*.png', {
  eager: true,
  query: '?url',
  import: 'default',
});

export const CAR_IMAGES: readonly string[] = Object.entries(modules)
  .sort(([left], [right]) => left.localeCompare(right))
  .map(([, url]) => url);

/**
 * Картинка машины по её номеру.
 *
 * Номер берётся по остатку: файлов может стать меньше, чем было, когда дефолт
 * сохраняли, и машина должна остаться машиной, а не пропасть. Пустая папка —
 * `null`, и доска нарисует машину вектором.
 */
export function carImageUrl(image: number): string | null {
  if (CAR_IMAGES.length === 0) {
    return null;
  }

  const index = ((Math.trunc(image) % CAR_IMAGES.length) + CAR_IMAGES.length) % CAR_IMAGES.length;
  return CAR_IMAGES[index] ?? null;
}
